/* global DutyTransaction, $ */
import React from 'react';
import { IconSearch } from '../ui-kit/icons';
import axios from 'axios';
import axiosRetry from 'axios-retry';
import { Button, Col, Row, ButtonGroup, Form, ProgressBar } from '../ui-kit';
import { API_PATH } from '../../constants';
import CandidatesSelectTable, { filterFullCandidates } from './CandidatesSelectTable';
import Loader from '../general/Loader';

axiosRetry(axios, { retries: 3 });

class DutyExchangeForm extends React.Component {
  constructor(props) {
    super(props);
    const dutyTransactionManager = new DutyTransaction.FormManager('form.duty-transaction', {
      candidateFinderUrl: this.props.candidateFinderUrl
    });
    this.state = {
      candidates: [],
      skills: {},
      availabilityCodes: {},
      dutyFunctions: {},
      searchedCandidates: false,
      dutyTransactionManager,
      selectedCandidates: [],
      sortedBalance: -1,
      selectedGroups: [],
      filterAvailableOnly: false,
      loading: false,
      loadingProgress: 0,
      requestType: '',
      timeUnit: 'shift',
      dropdownOpen: false,
      groups: []
    };
  }

  toggleDropdown = () => {
    this.setState({ dropdownOpen: !this.state.dropdownOpen });
  };

  handleCheckbox = e => {
    const { selectedCandidates } = this.state;
    const index = selectedCandidates.indexOf(Number(e.target.value));
    if (index !== -1) {
      selectedCandidates.splice(index, 1);
      this.setState({ selectedCandidates });
      return;
    }
    selectedCandidates.push(Number(e.target.value));
    this.setState({ selectedCandidates });
  };

  filterGroups = e => {
    if (e === 'none') {
      this.setState({ selectedGroups: [] });
      return;
    }
    if (e === 'all') {
      this.setState({ selectedGroups: [...this.state.uniqueGroupIds] });
      return;
    }
    const { selectedGroups } = this.state;
    const index = selectedGroups.indexOf(Number(e));
    if (index === -1) {
      selectedGroups.push(Number(e));
    } else {
      selectedGroups.splice(index, 1);
    }
    this.setState({ selectedGroups });
  };

  toggleFilterAvailableOnly = () => {
    this.setState(prevState => ({
      filterAvailableOnly: !prevState.filterAvailableOnly
    }));
  };

  sortBalance = type => {
    this.setState({ sortedBalance: type });
  };

  toggleSaveButton = toggle => {
    document.querySelector('#save-duty-transaction').disabled = toggle;
  };

  // Will take care of the selection logic. Can recieve 'all', 'available' or 'none'
  select = selection => {
    let selectedCandidates = [];
    switch (selection) {
      case 'all': {
        selectedCandidates = filterFullCandidates(this.state.candidates);
        break;
      }
      case 'available': {
        selectedCandidates = this.state.candidates.filter(candidate => candidate.fully_available);
        break;
      }
      default: {
        break;
      }
    }
    selectedCandidates = selectedCandidates.map(candidate => Number(candidate.user.id));
    this.setState({ selectedCandidates });
    this.toggleSaveButton(selectedCandidates.length === 0);
  };

  // creates a lookup table { id => object } and sets this in the state
  setIdMap = (key, data) => {
    const values = this.state[key];
    for (const item of data) {
      values[item.id] = item;
    }
    this.setState({ [key]: values });
  };

  setupCandidates = data => {
    this.setState({
      candidates: data,
      searchedCandidates: true,
      loading: false,
      loadingProgress: 0
    });

    this.setupGroups(data);

    axios.get(`${API_PATH}/skills`).then(response => this.setIdMap('skills', response.data));

    axios.get(`${API_PATH}/availability_codes`).then(response => this.setIdMap('availabilityCodes', response.data));

    axios.get(`${API_PATH}/standby_duty_functions`).then(response => this.setIdMap('dutyFunctions', response.data));

    this.loadContractStatistics(data);
  };

  // Setups the necessary state variables for the group selection filter
  setupGroups = candidates => {
    const groups = [];
    for (const candidate of candidates) groups.push(...candidate.groups);
    const uniqueGroupIds = [...new Set(groups.map(group => group.id))];
    const uniqueGroups = uniqueGroupIds
      .map(id => groups.find(group => group.id === id))
      .sort((g1, g2) => {
        // sort groups in filter by name
        if (g1.name > g2.name) return 1;
        if (g1.name < g2.name) return -1;
        return 0;
      });

    this.setState({
      groups: uniqueGroups,
      uniqueGroupIds,
      selectedGroups: [...uniqueGroupIds]
    });
  };

  // load contract statistics for the progress bar, balance and contract
  // constraint statistics table
  loadContractStatistics = data => {
    const urlFormat = `${API_PATH}/users/{0}/contract_statistics?time_unit=${this.state.timeUnit}`;

    const CancelToken = axios.CancelToken;

    this.cancelLoadingContracts = CancelToken.source();

    const contractRequests = data.map(candidate =>
      axios
        .get(String.format(urlFormat, candidate.user.id), {
          cancelToken: this.cancelLoadingContracts.token
        })
        .catch(error => {
          console.log(error);
        })
    );

    // when all requests have been loaded, update the candidates by setting a
    // new attribute on them with their contract statistics, if any
    Promise.all(contractRequests)
      .then(responses => {
        const contractsPerUser = {};
        for (const response of responses) {
          if (!response || !response.data[0]) continue;
          // for now, we'll only show the first active contract
          [contractsPerUser[response.data[0].user_id]] = response.data;
        }

        const candidates = data.map(candidate => {
          // find the response with contract statistics for this user
          const contractStatistics = contractsPerUser[candidate.user.id] || {};
          // extend the candidate object with the contractStatistics property
          return {
            ...candidate,
            contractStatistics: { ...contractStatistics, loaded: true }
          };
        });
        this.setState({ candidates });
      })
      .catch(error => {
        console.log(error);
      });
  };

  findCandidates = () => {
    this.setState({ loading: true, searchedCandidates: false });
    const startTime = $('input[id*=start_time]').first().val();
    const endTime = $('input[id*=end_time]').first().val();
    const skillFilterId = $('input[name*=candidate_skill_filter_id]:checked').val();
    const requestedDutyFunctionIds = $('input[name*=requested_duty_function_ids]:checked').val();

    const requestType = this.props.entityType === 'Membership' ? 'duty_exchanges' : 'duty_requests';
    this.setState({ requestType });
    let params = {
      start_time: startTime,
      end_time: endTime,
      requested_duty_function_ids: requestedDutyFunctionIds,
      candidate_skill_filter_id: skillFilterId
    };

    if (this.props.scheduleType) {
      params.schedule_type = this.props.scheduleType;
    }

    // Stop loading contracts if in progress
    this.cancelLoadingContracts && this.cancelLoadingContracts.cancel();

    for (const key of Object.keys(params).filter(key => params[key] === undefined)) delete params[key];

    this.loadCandidatesPaginated(params, requestType).then(candidates => {
      this.setupCandidates(candidates);
    });
  };

  loadCandidatesPaginated = (params, requestType, fromPage = 1) => {
    const apiEndPoint = this.props.entityType === 'Membership' ? 'memberships' : 'groups';

    const paginatedParams = { ...params, page: fromPage };

    const queryParams = Object.entries(paginatedParams)
      .map(([key, value]) => `${key}=${value}`)
      .join('&');

    const url = `${API_PATH}/${apiEndPoint}/${this.props.ownerId}/${requestType}/find_candidates?${queryParams}`;

    return new Promise((success, failure) => {
      axios
        .get(url)
        .then(response => {
          const totalObjects = Number(response.headers['total']);
          const retrievedObjects = Number(response.headers['per-page']) * fromPage;

          if (retrievedObjects >= totalObjects) {
            // base case of recursion: we have reached the end of the
            // pagination. Return the result of the last page
            success(response.data);
          } else {
            this.setState({ loadingProgress: (retrievedObjects * 100) / totalObjects });
            // recurse: get the next page(s) and concatenate them to the results
            // we obtained for the current page
            this.loadCandidatesPaginated(params, requestType, fromPage + 1).then(nextPage => {
              success([...response.data, ...nextPage]);
            });
          }
        })
        .catch(error => {
          console.log(error);
          failure(error);
        });
    });
  };

  changeTimeUnit = timeUnit => {
    let { candidates } = this.state;
    candidates = candidates.map(candidate => {
      candidate.contractStatistics = null;
      return candidate;
    });
    this.setState({ timeUnit, candidates }, () => {
      this.loadContractStatistics(candidates);
    });
  };

  applicableAvailabilityCodes = () => {
    const applicable = {};

    for (const [id, code] of Object.entries(this.state.availabilityCodes)) {
      if (code.purposes.include('duty_request')) applicable[id] = code;
    }
  };

  render() {
    const disableSelectControls = this.state.candidates.length === 0;
    return (
      <>
        <Row className="mb-5">
          <Col md={3}>
            <Form.Label>
              {I18n.t('activerecord.attributes.schedule/exchanges/duty_exchange.preselected_candidate')}
            </Form.Label>
          </Col>
          <Col md={9}>
            <div className="candidate-select-buttons">
              <Button variant="primary" onClick={() => this.findCandidates()}>
                <IconSearch />
                {` ${I18n.t('schedules.exchanges.duty_exchange.candidates.find')}`}
              </Button>
              <ButtonGroup className="ms-2">
                <Button variant="secondary" onClick={() => this.select('all')} disabled={disableSelectControls}>
                  {I18n.t('schedules.exchanges.duty_exchange.candidates.select_all')}
                </Button>
                <Button variant="secondary" onClick={() => this.select('available')} disabled={disableSelectControls}>
                  {I18n.t('schedules.exchanges.duty_exchange.candidates.select_available')}
                </Button>
                <Button variant="secondary" onClick={() => this.select('none')} disabled={disableSelectControls}>
                  {I18n.t('schedules.exchanges.duty_exchange.candidates.select_none')}
                </Button>
              </ButtonGroup>
              <ButtonGroup className="float-right">
                <Button
                  variant={this.state.timeUnit === 'shift' ? 'primary' : 'outline-secondary'}
                  onClick={() => this.changeTimeUnit('shift')}
                >
                  {I18n.t('reports.group_reports.standby_duty_hours.mode.shifts')}
                </Button>
                <Button
                  variant={this.state.timeUnit === 'hour' ? 'primary' : 'outline-secondary'}
                  onClick={() => this.changeTimeUnit('hour')}
                >
                  {I18n.t('reports.group_reports.standby_duty_hours.mode.hours')}
                </Button>
              </ButtonGroup>
            </div>
          </Col>
        </Row>
        <div className="mb-3">
          {this.state.loading && (
            <>
              <Loader url={this.props.loaderPath} />
              <ProgressBar now={this.state.loadingProgress} />
            </>
          )}
          {this.state.searchedCandidates && (
            <CandidatesSelectTable
              translations={this.props.translations}
              candidates={this.state.candidates}
              headers={this.props.headers}
              skills={this.state.skills}
              availabilityCodes={this.state.availabilityCodes}
              dutyFunctions={this.state.dutyFunctions}
              selectedCandidates={this.state.selectedCandidates}
              selectedGroups={this.state.selectedGroups}
              filterAvailableOnly={this.state.filterAvailableOnly}
              toggleFilterAvailableOnly={this.toggleFilterAvailableOnly}
              onChange={this.handleCheckbox}
              filterGroups={this.filterGroups}
              sortBalance={this.sortBalance}
              sortedBalance={this.state.sortedBalance}
              groups={this.state.groups}
              toggleDropdown={this.toggleDropdown}
              dropdownOpen={this.state.dropdownOpen}
              requestType={this.state.requestType.substring(0, this.state.requestType.length - 1)}
            />
          )}
        </div>
      </>
    );
  }
}

export default DutyExchangeForm;
